export enum BarcodeType {
  HBS_KIT_CODE = 'HBS_KIT_CODE',
  HBS_SAMPLE_CODE = 'HBS_SAMPLE_CODE',
}
